export const ADDRESS_FIELD_TEST_IDS = {
    textField: 'address-field-text-field',
    prediction: (i: number) => `address-field-suggestion-${i}`,
    error: 'address-field-error'
};
